module.exports = __webpack_public_path__ + "js/0.7ae9ce6f.worker.js"